import { styled as styledMui } from '@mui/material/styles';
import { Alert } from '@mui/material';

export const CustomAlert = styledMui(Alert)(() => ({
	marginTop: 5,
	marginBottom: 5,
}));

export const CustomInput = styledMui('input')(() => ({
	display: 'none',
}));

export const CustomLabel = styledMui('label')(() => ({}));

